<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <div class="banner_page">
      <!-- loading 遮罩仅盖住轮播，避免挡住下方登录/注册按钮 -->
      <div class="banner_carousel_wrap" v-loading="adLoading">
        <el-carousel
          height="600px"
          :indicator-position="
            adInfo['头部轮播图'].length <= 1 ? 'none' : 'block'
          "
        >
          <el-carousel-item
            v-for="(item, index) in adInfo['头部轮播图']"
            :key="index"
          >
            <div class="carousel_item">
              <img :src="item.imageArrays" class="carousel_img" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="btn_view" v-if="!headerToken">
        <el-button class="btn_item" @click="toLogin">登录</el-button>
        <el-button class="btn_item btn_region" @click="toLogin"
          >注册</el-button
        >
      </div>
    </div>
    <!-- banner end -->
    <div class="main">
      <!-- 练习系统 -->
      <div class="practiceSystem w1200">
        <div class="left">
          <div class="title">套题模考</div>
          <ul class="leftBox">
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: '托福' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_01.png"
                /><span>托福</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: '雅思' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_02.png"
                /><span>雅思</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: 'GRE' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_03.png"
                /><span>GRE</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: 'SAT' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_04.png"
                /><span>SAT</span>
              </router-link>
            </li>
          </ul>
          <div class="title">单项练习</div>
          <ul class="leftBox">
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: '托福' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_05.png"
                /><span>托福</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: '雅思' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_06.png"
                /><span>雅思</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: 'GRE' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_07.png"
                /><span>GRE</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: 'SAT' },
                }"
              >
                <img
                  class="practiceSystem_img"
                  src="../../assets/index/practiceSystem_08.png"
                /><span>SAT</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="right">
          <!-- <div class="title_2">全真模考系统</div> -->
          <div class="xdd-calendar" :class="'ExamType' + ExamType">
            <div class="dayData" :class="{ no: !ksCon }">
              <div class="nowDay">
                <div>
                  {{ getDay }}
                  <span>周{{ week }}</span>
                </div>
              </div>
              <div class="dayData2">
                {{ getYear }}年{{ getMonth }}月<br />
                农历{{ nlMonth }}{{ nlDay }}
              </div>
              <div class="koContent">
                <el-carousel
                  height="80px"
                  :autoplay="false"
                  trigger="click"
                  @change="gekoContent"
                >
                  <el-carousel-item
                    v-for="(item, index) in ksList"
                    :key="index"
                  >
                    <div class="item">
                      {{ item.ChineseName }}
                      <span>{{ item.EnglishName }}</span>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <xdd-calendar @change="changeDay" :ExamType="ExamType" />
            <div class="dayTips" v-if="dayTips">
              {{ "考试提醒：" + dayTips }}
            </div>
          </div>
        </div>
      </div>
      <!-- publicClass_index end -->
      <div class="courseClass_index clearfix w1200">
        <div class="title">
          入学测试
          <!-- <span>
            <router-link :to="{ path: '/course_list', query: { nav: 8 } }"
              >查看更多</router-link
            >
          </span> -->
        </div>
           <div
      v-loading="adLoading"
      class="swiper_test w1200"
      :class="{ swiper_test_1: Math.ceil(adInfo['模拟考试'].length / 4) > 1 }"
    >
      <div>
        <el-carousel
          :height="
            Math.ceil(adInfo['模拟考试'].length / 4) <= 1 ? '233px' : '297px'
          "
          :autoplay="false"
          :arrow="
            Math.ceil(adInfo['模拟考试'].length / 4) <= 1 ? 'none' : 'always'
          "
          :indicator-position="
            Math.ceil(adInfo['模拟考试'].length / 4) <= 1 ? 'none' : 'block'
          "
        >
          <el-carousel-item
            v-for="(item, index) in Math.ceil(adInfo['模拟考试'].length / 4)"
            :key="index"
          >
            <div class="test_list">
              <img
                v-for="(item1, index1) in adInfo['模拟考试'].slice(
                  index * 4,
                  (index + 1) * 4
                )"
                :key="index1"
                :src="item1.imageArrays"
                class="finger_shape list_item"
                alt=""
                @click="submitAdaptive(item1)"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
      </div>
      <div class="teacher_index">
        <div class="title w1200">
          师资介绍
          <!-- <span>
            <router-link :to="{ path: '/teacher_list', query: { nav: 1 } }">查看更多</router-link>
          </span> -->
        </div>
        <div class="teacher_list w1200">
          <swiper :options="swiperOption2">
            <swiper-slide
              class="theClass_li"
              v-for="(item, index) in teacherClass"
              :key="index"
            >
              <dl>
                <dt>
                  <img :src="item.cover" />
                </dt>
                <dd>
                  <h2>{{ item.name }}</h2>
                  <p class="p2" v-if="item.degrees">
                    {{ item.degrees }}
                  </p>
                </dd>
              </dl>
            </swiper-slide>
            <div
              class="swiper-pagination swiper-pagination2"
              slot="pagination"
            ></div>
          </swiper>
        </div>
      </div>
      <!-- teacher_index emd -->
    </div>
    <my-modal ref="myModal">
      <template #modalMIddle>
        <div style="text-align: center">
          <img
            src="../../assets/index/practiceSystem_modal.png"
            alt=""
            class="modal_img"
          />
          <div>
            <div class="modal_desc_title">解锁练习</div>
            <div class="modal_desc_desc">
              购买任意正价课程即可解锁所有练习。<br />
              随时随地畅快练习。
            </div>
          </div>
        </div>
      </template>
      <template #modalFooter>
        <div class="footer_modal" @click="toList">立即购买</div>
      </template>
    </my-modal>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import adverCom from "@/api/advertisingPosition";
import banner from "../../page2/banner/banner.vue"; //头部banner图
import myModal from "../../components/myModal.vue";
import xddCalendar from "../../components/xdd-calendar/xdd-calendar.vue";
import { testopiaTeacherList } from "@/api/common";
export default {
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    banner,
    myModal,
    xddCalendar,
  },
  metaInfo() {
    return {
      title: "启德考培在线",
      meta: [
        {
          name: "keywords",
          content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程.",
        },
      ],
    };
  },
  data() {
    return {
      swiperOption1: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination1",
          type: "bullets",
          progressbarOpposite: false,
        },
        autoplay: {
          delay: 2500, // 每张幻灯片轮播的时间间隔（毫秒）
          disableOnInteraction: false, // 用户操作后是否停止自动轮播
        },
      },
      swiperOption2: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination2",
          type: "bullets",
          progressbarOpposite: false,
        },
        autoplay: {
          delay: 2500, // 每张幻灯片轮播的时间间隔（毫秒）
          disableOnInteraction: false, // 用户操作后是否停止自动轮播
        },
      },
      positions: false,
      policyDtos: "",
      pageTypeId: 13,

      courseClase: [],
      courseClase_p: [],
      cur: 21,

      bigList: [],
      bigList_p: [],

      teacherClass: [],
      teacherClass_p: [],

      getYear: "", //选中年
      getMonth: "", //选中月
      getDay: "", //选中日
      nlMonth: "", //农历月
      nlDay: "", //农历日
      week: "", //星期
      ksCon: "", //考试内容
      kpType: "", //考试类型
      ksList: [],
      ExamType: null,
      dayTips: "", //提示文字
      adInfo: {
        头部轮播图: [],
        模拟考试: [],
      },
      adLoading: true,
      headerToken: false,
    };
  },
  watch: {
    $route() {
      this.syncHeaderTokenFromCookie();
    },
  },
  async created() {
    console.log("store", this.$store);
    //自动触发写入的函数
    try {
      let info = await adverCom("home");
      console.log(info, "info");
      this.adInfo = info;
    } catch (error) {}
    this.adLoading = false;
   
    this.courseList(26);
    this.teacherList(34);
  },
  beforeDestroy() {
    //在组件生命周期结束的时候销毁。
  },
  mounted: function () {
    this.syncHeaderTokenFromCookie();
  },
  methods: {
    submitAdaptive(target) {
      // let {
      //   adaptiveType: target
      // } = this;
      if (!this.$cookies.isKey("token")) {
        this.$refs.header.Personalover();
        return;
      }
      if (!target.jumpUrl) this.$message.warning("请选择考试");
      this.$utils.gatAllNavUrl({
        ...target,
        paperId: target.jumpUrl,
        restart: 3,
        Title: target.title,
        CourseType: target.moreFieldsValue.coursetype,
      });
    },
    /** 与 Header 一致：仅根据 cookie 判断；需在路由变化、退出登录后重新调用，否则同页复用实例时状态会过期 */
    syncHeaderTokenFromCookie() {
      const t = this.$cookies.get("token");
      this.headerToken = !!(t && String(t).trim());
    },
    toLogin() {
      this.$refs.header.Personalover();
    },
    async changeDay(date) {
      console.log(date, "加载完成");
      let that = this;
      this.getYear = date.year; //选中年
      this.getMonth = date.month; //选中月
      this.getDay = date.day; //选中日
      this.nlMonth = date.IMonthCn;
      this.nlDay = date.IDayCn;
      let arr = [`日`, `一`, `二`, `三`, `四`, `五`, `六`];
      this.week = date.week == 7 ? arr[0] : arr[date.week];
      let nowDate = date.year + "-" + date.month + "-" + date.day;
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/CalendarReminders?nowDate=" +
            nowDate
        )
        .then(function (res) {
          console.log(res.data.results, "resresres");
          if (res.data.results.length == 0) {
            that.ksList = [];
            that.ksCon = "";
            that.kpType = "";
            that.dayTips = "";
            that.ExamType = null;
          }
          that.ksList = res.data.results;
          that.ksCon = res.data.results[0].ChineseName;
          that.kpType = res.data.results[0].EnglishName;
          that.ExamType = res.data.results[0].ExamType;
          that.dayTips = res.data.results[0].Remark;
        })
        .catch(function () {
          // console.log('错误');
        });
    },
    gekoContent(e) {
      let that = this;
      console.log(e, "e");
      that.ExamType = that.ksList[e].ExamType;
      that.dayTips = that.ksList[e].Remark;
    },
    //精品课程
    courseList(e) {
      let that = this;
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=" + e
        )
        .then(function (response) {
          console.log(response, "response");
          that.courseClase = response.data.results;
          let courseClases = JSON.stringify(that.courseClase);
          sessionStorage.setItem("courseClase", courseClases);
          var bobao = [];
          for (var i = 0; i < that.courseClase.length; i++) {
            bobao.push(JSON.parse(that.courseClase[i].MoreFieldsValue));
          }
          that.courseClase_p = bobao;
        })
        .catch(function () {
          // console.log('错误');
        });
    },
    // 启德教师
    async teacherList(e) {
      let res = await testopiaTeacherList({
        page: 1,
        page_size: 10,
      });
      console.log(res, "res");
      this.teacherClass = res.data.data.items;
    },
    toList() {
      this.$router.push({
        path: "/course_list",
        query: {
          nav: 8,
        },
      });
    },
  },
};
</script>

<style scoped>
@import url("./index.css");

.footer_modal {
  width: 160px;
  height: 42px;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  padding: 6px 0;
  box-sizing: border-box;
  text-align: center;
  background: linear-gradient(100deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 30px;
  margin: 0 auto;
  margin-bottom: 74px;
  cursor: pointer;
}

.modal_img {
  margin: 34px 94px 0 94px;
}

.modal_desc_title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}

.modal_desc_desc {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin: 30px 94px 38px 94px;
}
</style>



// WEBPACK FOOTER //
// src/page2/index/index.vue